module.exports = __webpack_public_path__ + "static/media/kakao_url.7f6c19c8.png";